import $ from 'jquery'

export const matchHeight = () => {
	if (typeof $.fn.matchHeight !== 'function') return false
	$.fn.matchHeight._applyDataApi()
}

export default matchHeight
